import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const BASE_URL = 'https://adera-web-api.azurewebsites.net/v1';

const Signin = () => {
  const [themeMode, setThemeMode] = useState('light');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    let mode = 'light';
    if (document.documentElement) {
      if (document.documentElement.hasAttribute('data-bs-theme-mode')) {
        mode = document.documentElement.getAttribute('data-bs-theme-mode');
      } else if (localStorage.getItem('data-bs-theme')) {
        mode = localStorage.getItem('data-bs-theme');
      }
      document.documentElement.setAttribute('data-bs-theme', mode);
      setThemeMode(mode);
    }
  }, []);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage('');

    const payload = {
      email,
      password,
      role: 'Admin'
    };

    try {
      const response = await axios.post(`${BASE_URL}/auth/login`, payload);

      const token =
        response.data?.token ||
        response.data?.data?.token ||
        response.data?.data?.accessToken ||
        response.data?.accessToken;

      const userData =
        response.data?.user ||
        response.data?.data?.user ||
        response.data?.data;

      if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        navigate('/dashboarda');
      } else {
        setErrorMessage('Authentication successful, but the session token was not found.');
      }
    } catch (error) {
      const message =
        error.response?.data?.message || 'Invalid email, password, or role.';
      setErrorMessage(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="kt_body" className="app-blank vh-100 overflow-hidden">
      <style>{`
        body, html { height: 100%; overflow: hidden; }
        .full-height-bg { height: 100vh !important; }
      `}</style>

      <div className="d-flex flex-column flex-lg-row flex-column-fluid vh-100" id="kt_app_root">
        <div className="d-flex flex-column flex-column-fluid flex-center w-lg-50 p-10">
          <div className="d-flex flex-column w-100 mw-450px">
            <div className="mb-10">
              <Link to="/">
                <img
                  alt="Logo"
                  src={themeMode === 'dark' ? 'assets/EDSAAW.png' : 'assets/EDSAAB.png'}
                  className="h-70px"
                />
              </Link>
            </div>

            <div className="pt-5">
              <form className="form w-100" onSubmit={handleSignIn} noValidate>
                <div className="card-body">
                  <div className="text-start mb-10">
                    <h1 className="text-gray-900 mb-3 fs-3x">Admin Sign In</h1>
                    <div className="text-gray-500 fw-semibold fs-6">
                      EDSAA Management Portal
                    </div>
                  </div>

                  {errorMessage && (
                    <div className="alert alert-danger d-flex align-items-center p-4 mb-10">
                      <div className="d-flex flex-column text-danger">
                        <span className="fw-bold small">{errorMessage}</span>
                      </div>
                    </div>
                  )}

                  <div className="fv-row mb-8">
                    <label className="form-label fs-6 fw-bold text-gray-900">
                      Email
                    </label>
                    <input
                      type="email"
                      placeholder="Enter email"
                      className="form-control form-control-solid h-60px"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="fv-row mb-8">
                    <label className="form-label fs-6 fw-bold text-gray-900">
                      Password
                    </label>
                    <div className="position-relative mb-3">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Password"
                        className="form-control form-control-solid h-60px"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={loading}
                      />
                      <span
                        className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: 'pointer', zIndex: 10 }}
                      >
                        <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'} fs-2`} />
                      </span>
                    </div>
                  </div>

                  <div className="d-grid mb-10">
                    <button
                      type="submit"
                      className="btn btn-primary h-60px"
                      disabled={loading || !email || !password}
                    >
                      {!loading ? (
                        <span className="fs-4 fw-bold">Sign In</span>
                      ) : (
                        <span className="indicator-progress d-block">
                          Authenticating...
                          <span className="spinner-border spinner-border-sm align-middle ms-2" />
                        </span>
                      )}
                    </button>
                  </div>

                  <div className="text-gray-500 text-center fw-semibold fs-6">
                    Forgot password?{' '}
                    <Link to="/auth/forgot-password" className="link-primary">
                      Reset here
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div
          className="d-none d-lg-flex flex-lg-row-fluid w-50 bgi-size-cover bgi-position-center bgi-no-repeat full-height-bg"
          style={{
            backgroundImage: 'url(assets/aderabg.png)',
            backgroundSize: 'cover'
          }}
        />
      </div>
    </div>
  );
};

export default Signin;
